import {
  useStyle 
} from "@/classify"
import {
  Upload as AntdUpload, Modal 
} from "antd"
import React, {
  useImperativeHandle, useState 
} from "react"
import defaultClasses from "./upload.module.css"

const getBase64 = (img, callback) => {
  const reader = new FileReader()

  reader.addEventListener("load", () => callback && callback(reader.result))
  reader.readAsDataURL(img)
}

// eslint-disable-next-line react/display-name
const Upload = React.forwardRef((props, ref) => {
  const {
    fileLimit = 1,
    sizeLimit: propsSizeLimit, // 尺寸限制，单位kb
    name,
    showUploadList,
    listType,
    action,
    beforeUpload: propsBeforeUpload,
    ...otherProps
  } = props

  const [previewOpen, setPreviewOpen] = useState(false)
  const [previewImage, setPreviewImage] = useState("")
  const [previewTitle, setPreviewTitle] = useState("")
  const [fileList, setFileList] = useState([])
  const [errorState, setErrorState] = useState("")
  const classes = useStyle(defaultClasses, props.classes)

  useImperativeHandle(ref, () => ({
    fileList,
    setFileList,
    setErrorState,
  }))

  const handleCancel = () => setPreviewOpen(false)

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj)
    }

    setPreviewImage(file.url || file.preview || file.thumbUrl)
    setPreviewOpen(true)
  }

  const handleChange = ({
    fileList: newFileList 
  }) => {
    const notImageFileIndex = newFileList.findIndex((file) => {
      return file.type !== "image/jpeg" && file.type !== "image/png"
    })

    if (notImageFileIndex > -1) {
      newFileList.splice(notImageFileIndex, 1)
      setErrorState("You can only upload JPG/PNG file!")
    }

    const sizeLimit = propsSizeLimit * 1024 || 5 * 1024 * 1024

    const exceedSizeLimitFileIndex = newFileList.findIndex((file) => {
      return file.size > sizeLimit
    })

    if (exceedSizeLimitFileIndex > -1) {
      newFileList.splice(exceedSizeLimitFileIndex, 1)
      setErrorState(`Image must be smaller than ${Math.floor(sizeLimit / 1024 / 1024)}MB!`)
    }

    if (notImageFileIndex === -1 && exceedSizeLimitFileIndex === -1) {
      setErrorState("")
    }

    setFileList(newFileList)
  }

  const uploadButton = <div className={classes.uploadButton} />

  const beforeUpload = propsBeforeUpload || (() => false)

  return (
    <>
      <AntdUpload
        name={name}
        listType='picture-card'
        fileList={fileList}
        className={classes.root}
        onPreview={handlePreview}
        onChange={handleChange}
        showUploadList={true}
        beforeUpload={beforeUpload}
        {...otherProps}
      >
        {fileList.length >= fileLimit ? null : uploadButton}
      </AntdUpload>

      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        <img
          alt='preview image'
          style={{
            width: "100%",
          }}
          src={previewImage}
        />
      </Modal>
      <span className={classes.errorInfo}>{errorState}</span>
    </>
  )
})

export default Upload
